import api from 'services/api.service';

const resource = '/tasks';


export const emailAssignee = ({ id }) => api
  .post(`${resource}/${id}/email-assignee`);
